import { render, staticRenderFns } from "./MainFooter.vue?vue&type=template&id=8eeffc00&"
import script from "./MainFooter.vue?vue&type=script&lang=ts&"
export * from "./MainFooter.vue?vue&type=script&lang=ts&"
import style0 from "./MainFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports